export default (...props) => {
  const fullName = props.filter((element) => element)
  return fullName.join(' ')
}
